(() => {
  const body = document.body;
  const header = document.querySelector('[data-site-header]');

  if (header) {
    let lastY = window.scrollY;

    const updateHeader = () => {
      const y = window.scrollY;
      header.classList.toggle('is-solid', y > 20);

      if (y > lastY && y > 140) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }

      lastY = y;
    };

    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const overlay = document.querySelector('[data-drawer-overlay]');
  const drawers = [...document.querySelectorAll('[data-drawer]')];

  const closeDrawers = () => {
    drawers.forEach((drawer) => drawer.classList.remove('is-open'));
    if (overlay) overlay.classList.remove('is-visible');
    body.classList.remove('drawer-open');
    // Tüm toggle butonlarının aria-expanded = false yap
    document.querySelectorAll('[data-drawer-toggle]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
  };

  const openDrawer = (id) => {
    const target = document.getElementById(id);
    if (!target) return;

    drawers.forEach((drawer) => drawer.classList.remove('is-open'));
    target.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    body.classList.add('drawer-open');

    // Sadece bu drawer'a ait toggle butonunu expanded yap
    document.querySelectorAll(`[data-drawer-toggle="${id}"]`).forEach((btn) => {
      btn.setAttribute('aria-expanded', 'true');
    });
  };

  document.querySelectorAll('[data-drawer-toggle]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const targetId = trigger.getAttribute('data-drawer-toggle');
      const target = targetId ? document.getElementById(targetId) : null;
      const isOpen = target ? target.classList.contains('is-open') : false;
      if (!targetId) return;

      if (isOpen) {
        closeDrawers();
      } else {
        openDrawer(targetId);
      }
    });
  });

  document.querySelectorAll('[data-drawer-close]').forEach((closeBtn) => {
    closeBtn.addEventListener('click', closeDrawers);
  });

  if (overlay) {
    overlay.addEventListener('click', closeDrawers);
  }

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') closeDrawers();
  });

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    const currentCount = slider.querySelector('[data-hero-current]');
    const totalCount = slider.querySelector('[data-hero-total]');

    if (slides.length === 0) return;

    let active = 0;
    let timer;
    const interval = Number(slider.dataset.interval || 6000);

    const setSlide = (index) => {
      active = index;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === active);
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === active);
      });

      if (currentCount) currentCount.textContent = String(active + 1);
      if (totalCount) totalCount.textContent = String(slides.length);
    };

    const nextSlide = () => {
      setSlide((active + 1) % slides.length);
    };

    const start = () => {
      if (slides.length <= 1) return;
      timer = window.setInterval(nextSlide, interval);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        stop();
        setSlide(dotIndex);
        start();
      });
    });

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    setSlide(0);
    start();
  });

  document.querySelectorAll('[data-carousel-wrap]').forEach((wrap) => {
    const track = wrap.querySelector('[data-carousel-track]');
    if (!track) return;
    const autoplayInterval = Number(wrap.dataset.carouselAutoplay || 0);
    let autoplayTimer;

    const step = () => {
      const firstCard = track.querySelector('.product-card, .related-product-card, .collection-product-card');
      if (!firstCard) return 260;
      const cardWidth = firstCard.getBoundingClientRect().width;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      return cardWidth + gap;
    };

    const maxScrollLeft = () => Math.max(track.scrollWidth - track.clientWidth, 0);

    const goNext = () => {
      const current = track.scrollLeft;
      const next = current + step();
      const max = maxScrollLeft();

      if (next >= max - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      track.scrollTo({ left: next, behavior: 'smooth' });
    };

    const stopAutoplay = () => {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = undefined;
    };

    const startAutoplay = () => {
      if (autoplayInterval <= 0) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(goNext, autoplayInterval);
    };

    wrap.querySelectorAll('[data-carousel-arrow]').forEach((arrow) => {
      arrow.addEventListener('click', () => {
        const direction = arrow.dataset.direction === 'prev' ? -1 : 1;
        track.scrollBy({ left: step() * direction, behavior: 'smooth' });
        startAutoplay();
      });
    });

    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('mouseleave', startAutoplay);
    track.addEventListener('touchstart', stopAutoplay, { passive: true });
    track.addEventListener('touchend', startAutoplay, { passive: true });

    startAutoplay();
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    if (slides.length <= 1 || thumbs.length === 0) return;

    const setActive = (mediaId) => {
      slides.forEach((slide) => {
        slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
      });

      thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => setActive(thumb.dataset.mediaId));
    });
  });

  document.querySelectorAll('[data-instagram-feed]').forEach((feedSection) => {
    const source = feedSection.dataset.instagramSource;
    if (source !== 'instagram_api') return;

    const grid = feedSection.querySelector('[data-instagram-grid]');
    const accessToken = (feedSection.dataset.instagramAccessToken || '').trim();
    const limit = Math.max(1, Number(feedSection.dataset.instagramLimit || 6));
    const showHandle = feedSection.dataset.instagramShowHandle === 'true';
    const handleText = (feedSection.dataset.instagramHandle || '').trim();

    if (!grid || !grid.id || !accessToken || typeof window.Instafeed === 'undefined') return;

    const escapeHtml = (value) =>
      String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');

    const template = [
      '<a class="instagram-card" href="{{link}}" target="_blank" rel="noopener">',
      '<img src="{{image}}" loading="lazy" alt="Instagram gönderisi">',
      showHandle && handleText ? `<span>${escapeHtml(handleText)}</span>` : '',
      '</a>',
    ].join('');

    try {
      const feed = new window.Instafeed({
        target: grid.id,
        accessToken,
        limit,
        template,
      });

      const result = feed.run();
      if (result && typeof result.catch === 'function') {
        result.catch(() => {
          // API başarısız olursa section içinde mevcut manuel kartlar görünmeye devam eder.
        });
      }
    } catch (error) {
      // API başarısız olursa section içinde mevcut manuel kartlar görünmeye devam eder.
    }
  });

  document.querySelectorAll('[data-tabs]').forEach((tabs) => {
    const buttons = [...tabs.querySelectorAll('[data-tab-button]')];
    const panels = [...tabs.querySelectorAll('[data-tab-panel]')];

    const activate = (target) => {
      buttons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.target === target);
      });

      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.panel === target);
      });
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => activate(btn.dataset.target));
    });

    if (buttons[0]) activate(buttons[0].dataset.target);
  });

  const revealElements = [...document.querySelectorAll('.reveal')];
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -50px 0px' }
    );

    revealElements.forEach((el) => observer.observe(el));
  } else {
    revealElements.forEach((el) => el.classList.add('is-visible'));
  }

  /* ============================================================
     INFINITE SCROLL — Koleksiyon sayfası
     ============================================================ */
  (function initInfiniteScroll() {
    const grid = document.querySelector('[data-infinite-grid]');
    const loader = document.getElementById('infinite-scroll-loader');
    let sentinel = document.querySelector('[data-infinite-sentinel]');

    if (!grid || !sentinel || !loader) return;
    if (!('IntersectionObserver' in window) || !('fetch' in window)) return;

    let isFetching = false;

    const showLoader = () => {
      if (loader) loader.removeAttribute('hidden');
    };

    const hideLoader = () => {
      if (loader) loader.setAttribute('hidden', '');
    };

    const appendProducts = (html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('[data-infinite-grid]');
      const newItems = newGrid ? [...newGrid.children] : [];

      newItems.forEach((item) => {
        item.classList.add('infinite-item-enter');
        grid.appendChild(item);
        // Gelen kartları da reveal observer'ına kaydet
        revealObserver && revealObserver.observe(item);
        // Animasyonu mikro-gecikmeyle başlat
        requestAnimationFrame(() => {
          requestAnimationFrame(() => item.classList.add('infinite-item-enter--active'));
        });
      });

      // Yeni sentinel güncelle
      const newSentinel = doc.querySelector('[data-infinite-sentinel]');
      if (newSentinel) {
        sentinel.replaceWith(newSentinel);
        sentinel = document.querySelector('[data-infinite-sentinel]');
        if (sentinel) scrollObserver.observe(sentinel);
      } else {
        // Sonraki sayfa yok — sentinel'i kaldır, observer'ı durdur
        sentinel.remove();
        sentinel = null;
      }
    };

    const loadNext = async () => {
      if (isFetching || !sentinel) return;
      const nextUrl = sentinel.dataset.nextUrl;
      if (!nextUrl) return;

      isFetching = true;
      showLoader();
      scrollObserver.unobserve(sentinel);

      try {
        const res = await fetch(nextUrl, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('fetch failed');
        const html = await res.text();
        appendProducts(html);
      } catch (_) {
        // Hata durumunda sentinel'i geri gözlemle
        if (sentinel) scrollObserver.observe(sentinel);
      } finally {
        isFetching = false;
        hideLoader();
      }
    };

    const scrollObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) loadNext();
        });
      },
      { rootMargin: '0px 0px 300px 0px' }
    );

    scrollObserver.observe(sentinel);

    // Yeni eklenen kartlar için reveal observer referansı
    let revealObserver = null;
    if ('IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
      );
    }
  })();
})();
